<section class="container">
  <div id="account-lines" *ngFor="let line of accountLineDetailsModel?.customerAccountLineDetails">
    <div class="row m-t-md">
      <div class="col-12">
        <h5 class="title" id="msisdn-line">{{ line?.msisdn | phone }}</h5>
        <div class="row m-t-md">
          <div class="col-2 col-md-1 text-center n-padding">
            <ng-container *ngIf="line?.devicedetails?.lines[0]?.imageURL; else noImageAvailable">
              <img
                id="device-image"
                class="img-fluid"
                [src]="extTmoImagesUrl + line?.devicedetails?.lines[0]?.imageURL"
                alt="FPO Image"
              />
            </ng-container>
            <ng-template #noImageAvailable>
              <img id="no-image" class="img-fluid" [src]="imageUrl" alt="FPO Image" />
            </ng-template>
          </div>
          <div class="col-10 col-md-11">
            <p
              class="small m-t-xs"
              *ngIf="line?.primaryLineIndicator?.toLowerCase() === primaryConstant"
            >
              {{ line?.primaryLineIndicator }}
            </p>
            <p class="small m-t-xs" *ngIf="line?.lineStatus !== 'SUSPENDED'">
              {{ contentData?.lineStatus }}: {{ line?.lineStatus }}
            </p>
            <p class="small m-t-xs" *ngIf="line?.lineStatus === 'SUSPENDED'">
              {{ contentData?.lineStatus }}: {{ line?.lineStatus }} - {{ getSubStatus(line) }}
            </p>
            <div class="row m-t-md">
              <div class="col-8">
                <p class="bold">{{ contentData?.plan }}</p>
                <p class="m-t-xs" id="plan-line-{{ idx }}">{{ line?.planName }}</p>
              </div>
            </div>
            <tmo-p10m-usage-detail
              id="usage-details"
              [primaryMsisdn]="primaryMsisdn"
              [contentData]="contentData"
            ></tmo-p10m-usage-detail>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row m-t-xl m-b-xxl border-bottom"></div>
</section>
